<template>
  <div class="page-wrap">
    <a-card title="产品搜索排名">
      <div class="toolbar">
        <a-input v-model.trim="keyword" placeholder="产品名称或型号" allow-clear @pressEnter="search" />
        <a-button type="primary" @click="search">查询</a-button>
      </div>
      <a-table row-key="productId" :loading="loading" :columns="columns" :data-source="rows"
        :pagination="pagination" @change="changePage">
        <template slot="rank" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getSearchRanking } from '@/api'

export default {
  data() {
    return {
      keyword: '', loading: false, rows: [],
      pagination: { current: 1, pageSize: 20, total: 0, showSizeChanger: true },
      columns: [
        { title: '排名', key: 'rank', width: 80, scopedSlots: { customRender: 'rank' } },
        { title: '产品型号', dataIndex: 'productModel' },
        { title: '产品名称', dataIndex: 'productName' },
        { title: '搜索次数', dataIndex: 'searchCount', width: 120 },
        { title: '搜索人数', dataIndex: 'userCount', width: 120 },
        { title: '最近搜索时间', dataIndex: 'lastSearchedAt', width: 180 }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      getSearchRanking({ keyword: this.keyword, page: this.pagination.current, pageSize: this.pagination.pageSize })
        .then(res => {
          const data = res.data || {}
          this.rows = data.records || []
          this.pagination.total = Number(data.total || 0)
        }).finally(() => { this.loading = false })
    },
    search() { this.pagination.current = 1; this.loadData() },
    changePage(page) { this.pagination.current = page.current; this.pagination.pageSize = page.pageSize; this.loadData() }
  }
}
</script>

<style scoped>
.page-wrap { padding: 20px; }
.toolbar { display: flex; gap: 12px; margin-bottom: 16px; }
.toolbar .ant-input { width: 260px; }
</style>
